var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIdea(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "53573917-CCA0-4333-A370-823BE8033C0B") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mob-app-design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "reactions_main",
    transform: "translate(-216.000000, -57.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "no-active",
    transform: "translate(20.000000, 57.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "info",
    transform: "translate(196.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#2C2F49",
    strokeWidth: 1.5,
    fill: "#FFFFFF",
    cx: 12,
    cy: 12,
    r: 11.25
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.307692, 3.692308)",
    fill: "#2C2F49",
    fillRule: "nonzero",
    id: "Shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.71129355,14.8223104 L6.49899687,15.7713397 C5.86210683,16.0462351 5.35335738,16.2554593 4.97451879,16.3993103 C4.59527168,16.543608 4.15460968,16.6153846 3.6525328,16.6153846 C2.88151048,16.6153846 2.28179619,16.4088408 1.85407081,15.9985826 C1.42634543,15.5866863 1.21241465,15.0647425 1.21241465,14.4315599 C1.21241465,14.1864473 1.22793859,13.9343358 1.26021204,13.677459 C1.29275785,13.4202844 1.34450431,13.1306466 1.41531526,12.8069074 L2.21125759,9.72617323 C2.28206854,9.43117447 2.34225785,9.15166277 2.39046377,8.88734031 C2.43935056,8.62465589 2.46290882,8.38296837 2.46290882,8.16540492 C2.46290882,7.77197396 2.38842114,7.49678077 2.24012667,7.34205905 C2.0918322,7.18778408 1.80886074,7.10945528 1.38876116,7.10945528 C1.18300087,7.10945528 0.971521243,7.14549249 0.755956366,7.21518427 C0.539438265,7.28517388 0.354376567,7.35278087 0.199000999,7.4156226 L0.411842378,6.4658487 C0.933256095,6.23369167 1.43165625,6.03489139 1.9084046,5.86989461 C2.38515295,5.70445108 2.83561954,5.62165486 3.26171082,5.62165486 C4.02742232,5.62165486 4.61828524,5.82402908 5.03321018,6.22877751 C5.44813512,6.63382376 5.6555295,7.15889475 5.6555295,7.80592637 C5.6555295,7.93980011 5.64191201,8.17567999 5.61263441,8.51282143 C5.58403767,8.85070745 5.53079329,9.16029979 5.45317359,9.44189628 L4.66063563,12.5102706 C4.5956802,12.7567234 4.53726117,13.0384688 4.48646793,13.3555068 C4.43404059,13.6704601 4.40898441,13.9111052 4.40898441,14.072528 C4.40898441,14.4799569 4.4920511,14.7581284 4.65859301,14.9060001 C4.8263605,15.0538717 5.11532365,15.1274353 5.52575481,15.1274353 C5.71844231,15.1274353 5.93768391,15.0900578 6.18130081,15.0166432 C6.42423685,14.9432286 6.6014004,14.8787488 6.71129355,14.8223104 Z M6.91228771,1.94035027 C6.91228771,2.47495176 6.72804306,2.93152228 6.35778349,3.30693464 C5.98847715,3.68368722 5.54345755,3.87221243 5.02286089,3.87221243 C4.50063012,3.87221243 4.05452113,3.68368722 3.68099336,3.30693464 C3.30814646,2.93137337 3.12131449,2.47495176 3.12131449,1.94035027 C3.12131449,1.40679117 3.30814646,0.949476078 3.68099336,0.56929847 C4.05384025,0.189716519 4.50076629,0 5.02286089,0 C5.54332138,0 5.98847715,0.190163261 6.35778349,0.56929847 C6.72831541,0.949476078 6.91228771,1.40694008 6.91228771,1.94035027 Z"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdea);
export default __webpack_public_path__ + "static/media/idea.368691b8975efe8876bbb937f0a26d8d.svg";
export { ForwardRef as ReactComponent };